import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 2,
    class: "mt-2"
};
import { computed } from "vue";
import { useResponsive } from "@/composables/useResponsive";
export default /*@__PURE__*/ _defineComponent({
    __name: 'RegeneratingAnswersAlert',
    props: {
        startedOn: { default: null },
        stoppable: { type: Boolean, default: false },
        stopping: { type: Boolean, default: false },
        checking: { type: Boolean, default: false }
    },
    emits: ["stop"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { isPhone } = useResponsive();
        const startedText = computed(() => {
            if (!props.startedOn)
                return "";
            const started = new Date(props.startedOn);
            if (Number.isNaN(started.getTime()))
                return "";
            return ` (started ${started.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })})`;
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (_openBlock(), _createBlock(_component_v_alert, {
                type: "info",
                variant: "tonal",
                class: "mb-4",
                "data-testid": "regenerating-answers-alert"
            }, _createSlots({
                default: _withCtx(() => [
                    (__props.checking)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" AI is checking the new answers against the payer's policy. The page updates when it finishes. ")
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" AI is re-reading the documents" + _toDisplayString(startedText.value) + ". Answers update when it finishes; answers you entered stay as they are. ", 1)
                        ], 64)),
                    (__props.stoppable && _unref(isPhone))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_component_v_btn, {
                                variant: "text",
                                color: "primary",
                                class: "px-0",
                                "min-width": "0",
                                loading: __props.stopping,
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('stop')))
                            }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createTextVNode("Stop", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["loading"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 2
            }, [
                (__props.stoppable && !_unref(isPhone))
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                                variant: "text",
                                color: "primary",
                                loading: __props.stopping,
                                onClick: _cache[1] || (_cache[1] = ($event) => (emit('stop')))
                            }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                        _createTextVNode("Stop", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["loading"])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1024));
        };
    }
});
